import { FontConfig } from '../config/fonts';

export const fonts = {
	display: `${FontConfig.display.name}, system-ui, sans-serif`,
	ui: `${FontConfig.ui.name}, system-ui, sans-serif`,
};
